// Placeholder for translating strings
// if the translation key is in the format <specifier>.<english string> we split it and return the key
// in all other cases it's just an English string so we return that
export const t = (key: string): string => {
  const splitKey = key.split('.');
  if (splitKey.length > 1) return splitKey[splitKey.length - 1];
  return key;
};

export function isNumber(value: any) {
  return typeof value === 'number' && isFinite(value);
}
export { getRouterBasename } from './getRouterBasename';
